  export const getCalculationProperty = (output, prop) => {
    if (
      output?.calculation?.length !== 1
      || !output.calculation[0].startsWith('{')
    )
      return undefined;
    return JSON.parse(output.calculation[0])[prop];
  }